<template>
    <NoBookingServiceForm v-if="isNoBooking || isContingentExhausted" />

    <ExternalBookingDisclaimerForm v-else-if="isExternalBookingDisclaimer" />
    <ExternalBookingServiceForm v-else-if="isExternalBooking" />

    <NonHotelVoucherForm v-else-if="isNonRegularHotelVoucher" />

    <div v-else-if="isBooking">
        <BookableHotelVoucherMode v-if="isBookableHotelVoucher && !proceedToBooking"
                                  @proceed="proceedToBooking = true"
        />
        <CancellationOptin v-else-if="proceedToBooking && cancellationOptInRequired" />
        <BookingServiceForm v-else />
    </div>

</template>

<script>
import NonHotelVoucherForm from '@/components/NonHotelVoucherForm';
import BookingServiceForm from '@/components/BookingServiceForm';
import CancellationOptin from '@/components/CancellationOptin';
import ExternalBookingServiceForm from '@/components/ExternalBookingServiceForm';
import ExternalBookingDisclaimerForm from '@/components/ExternalBookingDisclaimerForm.vue';
import NoBookingServiceForm from '@/components/NoBookingServiceForm';
import { mapGetters } from 'vuex'
import BookableHotelVoucherMode from '@/components/BookableHotelVoucherMode'

export default {
    name: 'BookingDetails',
    components: {
        BookableHotelVoucherMode,
        BookingServiceForm,
        CancellationOptin,
        ExternalBookingServiceForm,
        NoBookingServiceForm,
        NonHotelVoucherForm,
        ExternalBookingDisclaimerForm
    },
    props: {
        code: String,
        token: String
    },
    computed: {
        ...mapGetters([
            'isExternalBooking',
            'isExternalBookingDisclaimer',
            'isNoBooking',
            'isBooking',
            'isNonRegularHotelVoucher',
            'isBookableHotelVoucher',
            'hasAlternativeSuggestions',
            'isContingentExhausted'
        ]),
        cancellationOptInRequired() {
            return this.$store.state.activationData.cancellationOptinEnabled
                && this.$store.state.cancellationOptinResult !== true;
        },
        proceedToBooking: {
            get() {
                return this.$store.state.proceedToBooking;
            },
            set(value) {
                this.$store.commit('setProceedToBooking', value);
            }
        },
        fetchMethod() {
            if (this.code) {
                return this.fetchBooking;
            }
            else if (this.token) {
                return this.fetchBookingForToken;
            }
        },
        voucherCode() {
            return this.$store.getters.voucherCode;
        },

    },
    methods: {
        fetchBooking() {
            return this.$store.dispatch('fetchBookingDetails', this.code, this.$store.getters.systemTicketCode);
        },
        fetchBookingForToken() {
            return this.$store.dispatch('fetchBookingDetailsToken', this.token);
        }
    },
    watch: {

    },
    created() {
        // TODO: @Andrii I'm pretty sure we can solve this more elegant way ;)
        this.$store.subscribe(mutation => {
            if (mutation.type === 'setActivationData') {
                //console.log(mutation.payload.token);
                //console.log(mutation.payload.suggestedAlternatives);
                if (mutation.payload.token && mutation.payload.suggestedAlternatives) {
                    this.$router.push({ name: 'BookingAlternatives', query: { token: mutation.payload.token } });
                }
            }
        });
        this.fetchMethod();

    }
}
</script>

<style lang="scss">
@use "@/styles/_variables";

.avp-voucher-info {
    margin: 0 -#{variables.$padding} 1.25rem;
    padding: 1.25rem;
}
</style>
